import React from 'react';
import BillingHistory from '../components/billing/BillingHistory';

const BillingPage = () => {
  const mockHistory = [
    { id: 1, date: new Date().toISOString(), description: 'Verification Report #123', type: 'SINGLE_REPORT', amount: 150.00, status: 'CHARGED' },
    { id: 2, date: new Date().toISOString(), description: 'Verification Report #124', type: 'SINGLE_REPORT', amount: 150.00, status: 'CHARGED' }
  ];

  return (
    <div className="billing-page" style={{ padding: '20px' }}>
      <h1>Billing & Invoices</h1>
      <BillingHistory history={mockHistory} />
    </div>
  );
};
export default BillingPage;
